// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"eff1d30e","345":"763a5afe","369":"4fa5fb75"}[chunkId] + ".chunk.js";
};